export const DEALER_BRANDING = 'DEALER_BRANDING';
export const ANAF_INTEGRATION = 'ANAF_INTEGRATION';
